export const enum NotificationTopicEnum {
    DataRequest,
    Study,
    ListingRequest,
}
